module.exports = __webpack_public_path__ + "media/newstyle/images/medium-shot-excited-woman-with-laptop-mini-3-1cb415c987495ef6d4641bdcd6e455a1.png";